import './swiper-slider';
import './testimonials-popup';
import './mobile-menu';
import './header-on-scroll';
import './cookies';
import './form';
import './scroll-top';
import $ from "jquery";

$(document).ready(function () {
        $('.duk-menu').on('click', function () {
            $('.duk-menu').removeClass('active');
            $(this).addClass('active');
            const filter = $(this).attr('data-filter');
            $('.filter').each(function (){
                if($(this).hasClass(filter)){
                    $(this).removeClass('hide')
                } else {
                    $(this).addClass('hide');
                }
            });
        });
});